import 'custom-event-polyfill';


export default class Dropdown {
	constructor(el) {
		if (!el) return false;

		this.dropdown = el;
		this.dropdownOptions = this.dropdown.querySelectorAll('.dropdown__option');
		this.selectedOption = this.dropdown.querySelector('.dropdown__selected');

		this.init();

		return el;
	}

	init() {
		this.selectedOption.addEventListener('click', this.toggleDropdown.bind(this));
		[...this.dropdownOptions].forEach(option => option.addEventListener('click', this.selectOption.bind(this)) );
	}

	toggleDropdown(action = false) {
		var ddClassList = this.dropdown.classList;

		// Close any other open dropdowns
		[...document.querySelectorAll('.dropdown')].forEach(dd => {
			if (dd !== this.dropdown) { return dd.classList.remove('is-open')};
		});

		switch(action) {
		    case 'open':
					ddClassList.add('is-open');
		      break;
		    case 'close':
					ddClassList.remove('is-open');
					break;
		    default:
					ddClassList.toggle('is-open');
		}
	}

	selectOption(event) {
		const el = event.currentTarget;
		const optionValue = el.getAttribute('data-option');
		const sectionClassName = el.getAttribute('data-section-name');
		var detail;

		if (sectionClassName) {
			const sectionEl = document.getElementById(sectionClassName);
			detail = { el, sectionEl, optionValue };
		} else {
			detail = { optionValue }
		}

		var event = new CustomEvent("optionChosen", { detail });

		// Fire the event
		this.dropdown.dispatchEvent(event);

		this.updateSelectedOptionText(el.innerText);
		this.toggleDropdown('close');
	}

	selectSection(sectionID) {

	}

	updateSelectedOptionText(text) {
		var prefix = this.selectedOption.getAttribute('data-prefix');

		if (prefix && prefix.length) {
			text = prefix+text;
		}

		this.selectedOption.innerText = text;
	}
}